import React from 'react';

const UserContext = React.createContext({});

export default UserContext;

export const WithUserContext = WrappedComponent => props => (
  <UserContext.Consumer>
    {props2 => <WrappedComponent {...props} {...props2} />}
  </UserContext.Consumer>
);
